var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholder = function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 268 322",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#daebdb",
    d: "M134 165c28.7 0 52-23.3 52-52s-23.3-52-52-52-52 23.3-52 52 23.3 52 52 52m0 18.2c-34.7 0-104 17.4-104 52v26h208.1v-26c0-34.6-69.4-52-104.1-52"
  })));
};
export default SvgPlaceholder;